import React from 'react';
import { number } from 'prop-types';

const stars = {
    4: ['#73CF11', '#73CF11', '#73CF11', '#73CF11', '#DCDCE6'],
    5: ['#00B67A', '#00B67A', '#00B67A', '#00B67A', '#00B67A']
};

const TPStars = ({ rating }) => {
    return (
        <svg
            width="160"
            height="31"
            viewBox="0 0 160 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M30 0.75H0V30.75H30V0.75Z" fill={stars[rating][0]} />
            <path
                d="M62.5 0.75H32.5V30.75H62.5V0.75Z"
                fill={stars[rating][1]}
            />
            <path d="M95 0.75H65V30.75H95V0.75Z" fill={stars[rating][2]} />
            <path
                d="M127.5 0.75H97.5V30.75H127.5V0.75Z"
                fill={stars[rating][3]}
            />
            <path
                d="M160 0.75H130V30.75H160V0.75Z"
                fill={stars[rating][4]}
            />
            <path
                d="M15 20.9687L19.5625 19.8125L21.4687 25.6875L15 20.9687ZM25.5 13.375H17.4688L15 5.8125L12.5312 13.375H4.5L11 18.0625L8.53125 25.625L15.0312 20.9375L19.0312 18.0625L25.5 13.375Z"
                fill="white"
            />
            <path
                d="M47.5 20.9687L52.0625 19.8125L53.9687 25.6875L47.5 20.9687ZM58 13.375H49.9687L47.5 5.8125L45.0313 13.375H37L43.5 18.0625L41.0313 25.625L47.5313 20.9375L51.5312 18.0625L58 13.375Z"
                fill="white"
            />
            <path
                d="M80 20.9687L84.5625 19.8125L86.4688 25.6875L80 20.9687ZM90.5 13.375H82.4688L80 5.8125L77.5313 13.375H69.5L76 18.0625L73.5313 25.625L80.0313 20.9375L84.0312 18.0625L90.5 13.375Z"
                fill="white"
            />
            <path
                d="M112.5 20.9687L117.063 19.8125L118.969 25.6875L112.5 20.9687ZM123 13.375H114.969L112.5 5.8125L110.031 13.375H102L108.5 18.0625L106.031 25.625L112.531 20.9375L116.531 18.0625L123 13.375Z"
                fill="white"
            />
            <path
                d="M145 20.9687L149.563 19.8125L151.469 25.6875L145 20.9687ZM155.5 13.375H147.469L145 5.8125L142.531 13.375H134.5L141 18.0625L138.531 25.625L145.031 20.9375L149.031 18.0625L155.5 13.375Z"
                fill="white"
            />
        </svg>
    );
};

TPStars.propTypes = {
    rating: number
};

TPStars.defaultProps = {
    rating: 5
};

export default TPStars;
